module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_11.a4afb217.jpg";